import React from 'react';
import styled from 'styled-components';
import { DialogActions as MuiDialogActions } from '@material-ui/core';

/**
 * DialogActions는 Dialog에서 수행할 액션 버튼을 담고 있는 컨테이너입니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
*/

const DialogActions = styled(({ classes, ...otherProps }) => (
  <MuiDialogActions
    classes={{
      ...classes,
    }}
    {...otherProps}
  />
))`
  padding: 0;
`;

/** @component */
export default DialogActions;
